<template>
    <transition-group name='fade'>
    <!-- 蒙版 -->
    <div class="mask"
         key="1"
         @click="show = true"
         v-if="show"
         @touchmove.prevent>

    </div>
    <div class="pop"
         v-show="show"
         key="2">
      <img :src="imgUrl" class="img_url">
      <div class="r-container">
        <div class="title">{{title}}</div>
        <div class="content">{{content}}</div>
      </div>
    </div>
    

  </transition-group>
</template>
<script>
export default {
  name: 'Popup',
  data() {
    return {
      show: false,
      title: '',
      imgUrl: '',
      content: ''
    }
  },
  mounted() {
    this.bus.$on('closePopUp', () => {
      this.show = false
    })
  }
}
</script>
<style lang="scss" scoped>
.img_url {
  width: 26px;
  height: 36px;
}
    // 渐变过渡
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s;
}
// 全局弹窗
.mask {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
}

.pop {
  height: 100px;
  width: 500px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 250px);
  z-index: 20;
  text-align: center;
  .r-container {
    margin-left: 20px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 22px;;
  }
  .content {
    color: #999999;
    line-height: 20px;
  }

  button {
    background: #f95644;
    border-radius: 32px;
    width: 180px;
    height: 50px;
    font-size: 18px;
    color: #ffffff;
  }
  .close {
    top: 0;
    right: 10px;
    position: absolute;
    display: block;
    width: 40px;
    height: 40px;
  }
}
</style>